import closeicon from "../../../assets/images/close.svg";
import BackdropModal from "../../../components/common/modal/backdropModal";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";

const benefitsData = [
  {
    label: "Death due to any cause",
    label_ar: "الوفاة لأي سبب",
    coverage: "BHD 3,000",
  },
  {
    label: "Permanent partial or total disability due to accident",
    label_ar: "العجز الجزئي أو الكلي الدائم بسبب حادث",
    coverage: "BHD 1,500",
  },
  {
    label: "Critical Illness",
    label_ar: "المرض الحرج",
    coverage: "BHD 500",
  },
  {
    label: "Medical Expenses due to Accident",
    label_ar: "المصاريف الطبية بسبب الحادث",
    coverage: "BHD 500",
  },
  {
    label: "Mortal Remains Repatriation",
    label_ar: "إعادة رفات المتوفى",
    coverage: "BHD 1,000",
  },
  {
    label: "Absence from work in violation to the terms of the work Permit *",
    label_ar: "الغياب عن العمل مخالفاً لشروط رخصة العمل *",
    coverage: "As per request",
    coverage_ar: "حسب الطلب",
  },
  {
    label:
      "Limited to the Services available at Al Hilal Hospitals & Medical Centre",
    label_ar: "تقتصر على الخدمات المقدمة في مستشفيات ومراكز الهلال الطبية",
    coverage: "OUT-PATIENT",
    coverage_ar: "العيادات الخارجية",
    isHeader: true,
  },
  {
    label: "Annual Limit per person",
    label_ar: "الحد السنوي للشخص الواحد",
    coverage: "BHD 2,000",
  },
  {
    label: "Deductible",
    label_ar: "قيمة الاقتطاع",
    coverage:
      "BHD 3 on Consultation & 20% coinsurance on all other services including, but not limited to, Investigations, medications, physiotherapy, Injections, IV Fluids & all minor surgeries",
    coverage_ar:
      "3 دينار بحريني للاستشارة وتأمين جزئي بما يعادل 20% على كل الخدمات الأخرى بما في ذلك على سبيل المثال لا الحصر الفحوصات والأدوية والعلاج الطبيعي والحقن والمحاليل الوريدية وكل العمليات الجراحية البسيطة",
  },
  {
    label:
      "Consultation: General Physician Specialist (if required by GP recommendation), incl. General Medicine, Paediatrics, Dermatology, ENT, Orthopaedics, Radiology, Ophthalmology",
    label_ar:
      "الاستشارة: طبيب عام اختصائي: إذا اقتضى الأمر عند إحالة (الطب الباطني، وطب الأطفال، وأمراض النساء والولادة، وأنف وأذن والحنجرة، وطب العيون، وجراحة العظام، وإشعة، وأمراض الجلدية، وعلم الأمراض)",
    coverage: "Covered",
    coverage_ar: "شامل",
  },
  {
    label:
      "Basic Standard Lab Investigations, X-Rays, Basic Ultrasound Scanning and Other Basic Investigations (As Prescribed by the treating Doctor)",
    label_ar:
      "الفحوصات المختبرية الأساسية الروتينية، والإشعة السينية، والتصوير بالموجات فوق الصوتية والفحوصات الأساسية الأخرى (وفقاً لرأي الطبيب المعالج)",
    coverage: "Covered",
    coverage_ar: "شامل",
  },
  {
    label:
      "Medicines (generic), Injections and IV Fluids (As Prescribed by the treating Doctor)",
    label_ar:
      "الأدوية (العامة)، والحقن والمحاليل الوريدية (وفقاً لرأي الطبيب المعالج)",
    coverage: "Covered",
    coverage_ar: "شامل",
  },
  {
    label: "Physiotherapy up to 6 sessions per person per year",
    label_ar: "العلاج الطبيعي بحد أقصى يصل إلى 6 جلسات للشخص الواحد في السنة",
    coverage: "Covered",
    coverage_ar: "شامل",
  },
  {
    label:
      "Pre-existing & Chronic Conditions: subject to 3 months waiting period",
    label_ar: "الأمراض السابقة والمزمنة – فترة انتظار مدتها 3 أشهر",
    coverage: "Covered up to BHD 300",
    coverage_ar: "حتى 300 دينار بحريني",
  },
  {
    label:
      "Outpatient: Minor surgeries: I&D, Drainage of Abscess, Nail Removal, POP/Cast Application, Foreign Body Removal",
    label_ar:
      "العيادات الخارجية: العمليات الجراحية البسيطة وتشمل: تصريف الخراج، وإزالة الظفر، واستخدام جبيرة جبسية، وإزالة الجسم الغريب",
    coverage: "Covered",
    coverage_ar: "شامل",
  },
  {
    label:
      "Limited to the Services mentioned below and as per the Physician's request",
    label_ar: "تقتصر المنفعة على الخدمات المذكورة أدناه ووفقاً لأمر الطبيب",
    coverage:
      "MATERNITY - Outpatient Only for married females spouses 16-45 years",
    coverage_ar:
      "رعاية الأمومة - العيادات الخارجية مخصصة فقط للأمهات المتزوجات التي تتراوح أعمارهن بين 16 - 45 عاماً",
    isHeader: true,
  },
  {
    label: "Check-up as per Standards ANC Care",
    label_ar: "الفحص الدوري وفقا لمعايير رعاية ما قبل الولادة",
    coverage: "Covered",
    coverage_ar: "شامل",
    subItems: [
      {
        text: "10 times Gynecologist Consultations",
        text_ar: "10 استشارات لطبيب أمراض النساء والولادة",
      },
      {
        text: "3 times Basic Ultrasound Scanning",
        text_ar: "3 مرات تصوير بالموجات فوق الصوتية الأساسية",
      },
      {
        text: "Required Basic Standard Lab Tests",
        text_ar: "الفحوصات المختبرية الأساسية المطلوبة",
      },
      { text: "Iron and Calcium Tablets", text_ar: "أقراص الحديد والكالسيوم" },
      {
        text: "One Post Delivery Consultation",
        text_ar: "استشارة واحدة بعد الولادة",
      },
    ],
  },
  {
    label: "Maternity Deductible",
    label_ar: "قيمة الاقتطاع للأمومة",
    coverage:
      "BHD 3 on Consultation & 20% coinsurance on all other services (Ultrasound, Lab Tests, Iron and Calcium Tablets & any other related treatments)",
    coverage_ar:
      "٣ دينار بحريني للاستشارة وتأمين جزئي بنسبة ٢٠٪ على جميع الخدمات الأخرى (الموجات فوق الصوتية، الفحوصات المخبرية، أقراص الحديد والكالسيوم، وأي علاجات أخرى ذات صلة)",
  },
  {
    label:
      "Limited to Al Hilal Hospitals Only and Limited to the Services Provided by the Network Provider",
    label_ar:
      "تقتصر المنفعة على الخدمات المقدمة في مستشفيات الهلال فقط والخدمات المقدمة من مزود الخدمات",
    coverage: "Dental",
    coverage_ar: "الأسنان",
    isHeader: true,
  },
  {
    label: "Consultation, Medicines, X-ray, Fillings and Extractions",
    label_ar: "الاستشارة والأدوية والإشعة السينية والحشو والخلع",
    coverage: "Covered",
    coverage_ar: "شامل",
  },
  {
    label: "Dental Deductible",
    label_ar: "قيمة الاقتطاع للأسنان",
    coverage:
      "BHD 3 on Consultation & 20% coinsurance on all other services (Medicines, X-ray, Fillings and Extractions)",
    coverage_ar:
      "٣ دينار بحريني للاستشارات وتأمين جزئي بما يعادل ٢٠٪ على كل الخدمات الأخرى (الأدوية والأشعة السينية والحشو والخلع)",
  },
];

const EssentialCareBenefitsModal = ({ show, onClose }) => {
  const translate = useLanguageTranslate();

  if (!show) return null;

  const renderBenefitRow = (benefit, index) => {
    const isHeaderRow = benefit.isHeader;
    const rowClass = isHeaderRow
      ? "bg-[#F6F8F9] font-semibold"
      : index % 2 === 0
      ? "bg-white"
      : "bg-[#F6F8F9]";

    return (
      <tr
        key={index}
        className={`${rowClass} border-b border-[#DDE2E4] last:border-b-0`}
      >
        <td className="p-4 text-[#48535B] font-medium">
          {translate(benefit.label, benefit.label_ar)}
          {benefit.subItems && (
            <ul className="mt-2 list-disc pl-6 space-y-1">
              {benefit.subItems.map((item, idx) => (
                <li key={idx} className="text-sm font-normal">
                  {translate(item.text, item.text_ar)}
                </li>
              ))}
            </ul>
          )}
        </td>
        <td className="p-4 text-center text-[#48535B]">
          {translate(benefit.coverage, benefit.coverage_ar || benefit.coverage)}
        </td>
      </tr>
    );
  };

  return (
    <BackdropModal show={show} onClose={onClose} hideClosebtn>
      <>
        {/* Header */}
        <div className="flex justify-between items-center mb-4 -mt-6">
          <h2 className="text-[#48535B] text-xl font-medium">
            {translate(
              "Domestic Helper insurance benefits & covers",
              "مزايا وتغطيات تأمين العمالة المنزلية"
            )}
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full"
          >
            <img src={closeicon} alt="Close" className="w-6 h-6" />
          </button>
        </div>
        <div className="w-full max-h-[80vh] overflow-y-auto relative">
          {/* Benefits Table */}
          <table className="w-full border-collapse">
            <thead>
              <tr className="sticky top-0 z-10 bg-[#F6F8F9]">
                <th className="text-left p-4 text-[#48535B] font-medium">
                  {translate("Description", "التفاصيل")}
                </th>
                <th className="text-center p-4 text-[#48535B] font-medium min-w-[200px]">
                  {translate("Benefits & Covers", "المزايا والتغطيات")}
                </th>
              </tr>
            </thead>
            <tbody>
              {benefitsData.map((benefit, index) =>
                renderBenefitRow(benefit, index)
              )}
            </tbody>
          </table>
        </div>
      </>
    </BackdropModal>
  );
};

export default EssentialCareBenefitsModal;
